const InfoSquare = ({ iconColor }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M7.66988 1.99902H16.3399C19.7299 1.99902 21.9999 4.37902 21.9999 7.91902V16.09C21.9999 19.62 19.7299 21.999 16.3399 21.999H7.66988C4.27988 21.999 1.99988 19.62 1.99988 16.09V7.91902C1.99988 4.37902 4.27988 1.99902 7.66988 1.99902ZM11.9899 9.06002C11.5199 9.06002 11.1299 8.66902 11.1299 8.19002C11.1299 7.70002 11.5199 7.31002 12.0099 7.31002C12.4899 7.31002 12.8799 7.70002 12.8799 8.19002C12.8799 8.66902 12.4899 9.06002 11.9899 9.06002ZM12.8699 15.78C12.8699 16.26 12.4799 16.65 11.9899 16.65C11.5099 16.65 11.1199 16.26 11.1199 15.78V11.36C11.1199 10.879 11.5099 10.48 11.9899 10.48C12.4799 10.48 12.8699 10.879 12.8699 11.36V15.78Z"
        fill={iconColor ?? "#57585C"}
      />
    </svg>
  );
};

export default InfoSquare;
